module.exports = __webpack_public_path__ + "static/bookings-background-d66d5ff6f113cc49494749f1bd7a5208.jpg";